export const styleConfig = {
  tabBar: { base: 'none', md: 'flex' },
};
